import React from 'react'

import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import {
  Button,
  ButtonProps,
  createMultiStyleConfigHelpers,
  useModalContext,
} from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const normal = definePartsStyle({
  dialog: {
    borderRadius: '8px',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    py: '10',
    maxH: 'calc(100vh - 2rem)',
    mx: 'auto',
    my: 'auto',
  },
  header: {
    px: '14',
    py: '0',
  },
  body: {
    pl: '14',
    // 14=3.5rem スクロールbarの右側の余白を6px（0.375rem）取るためにpaddingとmarginを調整
    pr: '3.125rem',
    mr: '0.375rem',
    pt: '0',
    pb: '4',
    mt: '8',
    overflow: 'auto',
  },
  footer: {
    px: '14',
    py: '0',
    mt: '4',
    display: 'flex',
    gap: '4',
  },
})

const sp = definePartsStyle({
  dialog: {
    borderRadius: '8px',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    py: '10',
    maxH: 'calc(100svh - 2rem)',
    mx: 'auto',
    my: 'auto',
    w: 'calc(100svw - 2rem)',
    maxW: '380px',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    px: '8',
    py: '0',
  },
  body: {
    pl: '8',
    pr: '1.75rem',
    mr: '0.25rem',
    pt: '4',
    mt: '4',
    pb: '2',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto',
  },
  footer: {
    px: '8',
    py: '0',
    mt: '8',
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '4',
  },
})

export const Modal = defineMultiStyleConfig({
  variants: {
    normal,
    sp,
  },
  defaultProps: {
    variant: 'normal',
  },
})

/** モーダルのfooterに表示するキャンセルボタン
 *
 * クリックするとModalのonCloseが呼ばれます
 * @param text ボタンに表示するテキスト デフォルトは「キャンセル」
 *
 */
export const ModalCancelButton: React.FC<{
  text?: string
  size?: ButtonProps['size']
}> = ({ text = 'キャンセル', size = 'md' }) => {
  const { onClose } = useModalContext()
  return (
    <Button variant="ghost" colorScheme="gray" size={size} onClick={onClose}>
      {text}
    </Button>
  )
}
